import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Country, CountryLabels } from '@shared/domain/common/country';
import { CreateOrderModel } from 'retail/app/orders/models/create-order.model';
import { CheckoutService } from 'retail/app/orders/providers/checkout.service';
import { OrdersService } from 'retail/app/orders/providers/orders.service';
import { SelectOption } from 'shared-ui/models/select-option';

@Component({
  selector: 'retail-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.scss'],
})
export class CustomerInfoComponent implements OnInit {
  @Output() back = new EventEmitter();
  @Output() next = new EventEmitter();
  countries: SelectOption[] = [
    { label: CountryLabels.CZ, value: Country.CZ },
    { label: CountryLabels.SK, value: Country.SK },
  ];
  formErrors: ValidationErrors = {};
  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required, Validators.minLength(9)]),
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    companyPurchase: new FormControl(),
    companyId: new FormControl(),
    companyVat: new FormControl(),
    companyName: new FormControl(),
    street: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    postalcode: new FormControl('', [Validators.required, Validators.minLength(5)]),
    country: new FormControl(this.countries[0].value, [Validators.required]),
    delivery: new FormControl(),
    deliveryName: new FormControl(),
    deliveryStreet: new FormControl(),
    deliveryCity: new FormControl(),
    deliveryPostalcode: new FormControl(),
    deliveryCountry: new FormControl(),
  });
  order: Partial<CreateOrderModel> = {};

  get showCompany(): boolean {
    return !!this.form.value.companyPurchase;
  }

  get showDelivery(): boolean {
    return !!this.form.value.delivery;
  }

  get isDeliveryPickup(): boolean {
    return this.order.isPickup ?? false;
  }

  constructor(
    private checkoutService: CheckoutService,
    private ordersService: OrdersService
  ) {}

  ngOnInit(): void {
    this.order = this.ordersService.loadOrder();
    this.form.patchValue(this.order.info ?? {});
    this.switchDelivery(!!this.order.info?.delivery);
    this.updateFormErrors();
    this.form.valueChanges.subscribe(() => this.updateFormErrors());
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.updateFormErrors();
    if (this.form.valid) {
      this.ordersService.patchOrder('info', this.form.value as any);
      this.next.emit();
    }
  }

  switchDelivery(value: boolean) {
    if (value) {
      this.form.controls.deliveryName.setValidators([Validators.required]);
      this.form.controls.deliveryStreet.setValidators([Validators.required]);
      this.form.controls.deliveryCity.setValidators([Validators.required]);
      this.form.controls.deliveryPostalcode.setValidators([Validators.required]);
      this.form.controls.deliveryCountry.setValidators([Validators.required]);
    } else {
      this.form.controls.deliveryName.clearValidators();
      this.form.controls.deliveryStreet.clearValidators();
      this.form.controls.deliveryCity.clearValidators();
      this.form.controls.deliveryPostalcode.clearValidators();
      this.form.controls.deliveryCountry.clearValidators();
    }
    this.form.controls.deliveryName.updateValueAndValidity();
    this.form.controls.deliveryStreet.updateValueAndValidity();
    this.form.controls.deliveryCity.updateValueAndValidity();
    this.form.controls.deliveryPostalcode.updateValueAndValidity();
    this.form.controls.deliveryCountry.updateValueAndValidity();
  }

  private updateFormErrors() {
    Object.keys(this.form.controls).forEach(control => {
      this.formErrors[control] = this.form.get(control)?.errors;
    });
  }
}
